<button
  aria-label="Vyhledávání"
  class="z-[2] right-0 inset-y-0 rounded-full p-2 text-xs font-medium uppercase leading-tight transition duration-150 ease-in-out text-black hover:text-orange-800"
  type="button"
  id="button-search-desktop"
  (click)="toggleSearchInput()"
>
  <la-icon icon="search" size="2x"></la-icon>
</button>
